<template>
  <el-row
    class="pagination-container"
    :class="{ hidden: hidden }"
    type="flex"
    justify="space-around"
  >
    <el-col :span="6"
      ><el-pagination
        :background="background"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :layout="layout"
        :page-sizes="pageSizes"
        :total="total"
        v-bind="$attrs"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-top:5px"
    /></el-col>
  </el-row>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 15,
    },
    pageSizes: {
      type: Array,
      default() {
        return [15, 25, 50, 100];
      },
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    background: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
    },
    currentPagesize() {
      this.page = 1;
    },
  },
};
</script>

<style scoped>
/* .pagination-container {
  width: 80vw;
  position: fixed;
  bottom: 0;
  height: 60px;
} */
.pagination-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 20px;
  >div:nth-child(1),>div:nth-child(3){
    width: 200px;
  }
  >div:nth-child(2){
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    flex: 1;
  }
}
</style>
